const ONE_MONTH_IN_SECONDS = 30 * 24 * 60 * 60;

const accountUrl = () => {
	if (import.meta.env.VUE_APP_IS_LOCAL) {
		return 'local.voicemod';
	}

	if (
		import.meta.env.VUE_APP_ENVIRONMENT === 'production' ||
		import.meta.env.VUE_APP_ENVIRONMENT === 'staging'
	) {
		return 'voicemod.net';
	}

	return 'voicemod.dev';
};

export class CookieService {
	static setCookie(
		name: string,
		value: string | null | undefined,
		expires: number | null = null,
		domain: string | null | undefined = undefined
	): void {
		const dateInSeconds = Math.round(Date.now() / 1000);
		const maxAge = expires ? expires - dateInSeconds : ONE_MONTH_IN_SECONDS;
		const resolvedDomain = domain === undefined ? accountUrl() : domain;
		const cookieParts = [`vm_${name}=${value ?? ''}`, `max-age=${maxAge}`];

		if (resolvedDomain) {
			cookieParts.push(`domain=${resolvedDomain}`);
		}

		document.cookie = cookieParts.join('; ');
	}

	static getCookie(cookieName: string): string | null {
		const voicemodCookie = `vm_${cookieName}`;
		const cookies = document.cookie.split(';');
		const cookie = cookies.find((cookie) => cookie.includes(voicemodCookie));

		if (!cookie) {
			return null;
		}

		const cookieValue = cookie.split('=')[1];
		if (['undefined', 'null'].includes(cookieValue)) {
			return null;
		}

		return cookieValue;
	}

	static deleteCookie(
		name: string,
		domain: string | undefined = undefined
	): void {
		const resolvedDomain = domain ?? accountUrl();
		const cookieParts = [
			`vm_${name}=`,
			'expires=Thu, 01 Jan 1970 00:00:01 GMT',
		];

		if (resolvedDomain) {
			cookieParts.push(`domain=${resolvedDomain}`);
		}

		document.cookie = cookieParts.join('; ');
	}
}
